export default function Menu() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			style={{ width: 24, height: 24, display: 'block' }}
		>
			<line x1={4} y1={6} x2={20} y2={6} />
			<line x1={4} y1={12} x2={20} y2={12} />
			<line x1={4} y1={18} x2={20} y2={18} />
		</svg>
	)
}
